import { createRouter, createWebHashHistory, createWebHistory , RouteRecordRaw } from "vue-router";
import store from "@/store";
import { role, validateRole } from "@/helpers/role";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { Form } from "vee-validate";

const createChildren = (prefix = "") => [
  {
    path: "dashboard",
    name: prefix+"dashboard",
    component: () =>  import("@/views/Dashboard.vue"),
  },
  {
    path: "products/stock",
    name: prefix + "stock",
    component: () => import("@/views/stock/Stock.vue"),
    // meta: { authorize: [role.admin] },
  },
  {
    path: "products/returnproduct/:mode/:voucherCode/:voucherBranch",
    name: prefix + "returnproduct",
    component: () => import("@/views/transfer/ReturnProductList.vue"),
    meta: { authorize: [role.admin] },
    props: true,
  },  
  // {
  //   path: "products/editreturnproduct/:voucherCode/:voucherBranch",
  //   name: prefix + "editreturnproduct",
  //   component: () => import("@/views/transfer/EditReturnProduct.vue"),
  //   meta: { authorize: [role.admin] },
  // },     
  {
    path: "admin/partners/:partnerCode/stock",
    name: prefix + "partnerStock",
    component: () => import("@/views/stock/Stock.vue"),
    meta: { authorize: [role.admin] },
    props: true
  },   
  {
    path: "2s/stock",
    name: prefix + "2SStock",
    component: () => import("@/views/stock/2SStock.vue"),
    // meta: { authorize: [role.admin] },
  },
  {
    path: "transfer/receive",
    name: prefix + "receive",
    component: () => import("@/views/transfer/Receive.vue"),
    props: true
  },
  {
    path: "sellorderreport",
    name: prefix + "sellorderreport",
    component: () => import("@/views/sellorder/SellOrderReport.vue"),
  },
  {
    path: "financial/overduereport",
    name: prefix + "overduereport",
    component: () => import("@/views/sellorder/OverdueReport.vue"),
  },
 
  // {
  //   path: "admin/reports/orders",
  //   name: prefix + "adminReportOrder",
  //   component: () => import("@/views/admin/orders/PartnerOrderSummaryReport.vue"),
  //   meta: { authorize: [role.admin] }
  // },
  // {
  //   path: "admin/reports/partners/:partnerCode/orders",
  //   name: prefix + "partnerOrderList",
  //   component: () => import("@/views/order/OrderList.vue"),
  //   props: true,
  //   meta: { authorize: [role.admin] }
  // },
 
  // {
  //   path: "admin/reports/partners/:partnerCode/orders/:orderCode",
  //   name: prefix + "partnerOrderDetail",
  //   component: () => import("@/views/order/OrderDetail.vue"),
  //   props: true,
  //   meta: { authorize: [role.admin] }
  // },
  {
    path: "reports/product-sales-summary",
    name: prefix + "productSalesSummaryReport",
    component: () => import("@/views/reports/SalesReport/SalesReport.vue"),
    props: true
  },
  {
    path: "order/create",
    name: prefix + "createOrder",
    component: () => import("@/views/order/CreateOrder.vue"),
    meta: { notCatch: true}
  },
  {
    path: "order/sellrequest",
    name: prefix + "sellrequestCreate",
    component: () => import("@/views/order/CreateOrder.vue"),
    meta: { notCatch: true}
  },
  {
    path: "order/:orderCode",
    name: prefix + "orderDetail",
    component: () => import("@/views/order/OrderDetail.vue"),
    props: true,
  },
  {
    path: "order/:srCode",
    name: prefix + "SellRequestDetail",
    component: () => import("@/views/sellrequest/SellRequestDetail.vue"),
    props: true,
  },
  {
    path: "order/sellrequestlist",
    name: prefix + "SellRequestList",
    component: () => import("@/views/sellrequest/SellRequestList.vue"),
    props: true,
  },
  {
    path: "order/nondeliveryreport",
    name: prefix + "NonDeliveryReport",
    component: () => import("@/views/reports/nondelivery/NonDeliveryReport.vue"),
    props: true,
  },
  {
    path: "order/aivoucherlist",
    name: prefix + "AIVoucherList",
    component: () => import("@/views/aivoucher/AIVoucherList.vue"),
    props: true,
  },
  {
    path: "order",
    name: prefix + "orderList",
    component: () => import("@/views/order/OrderList.vue"),
    props: true,
  },
  {
    path: "order2s",
    name: prefix + "order2SList",
    component: () => import("@/views/order2s/Order2SList.vue"),
    props: true,
  },
  {
    path: "order2s/:uoRefNo",
    name: prefix + "order2SDetail",
    component: () => import("@/views/order2s/Order2SDetail.vue"),
    props: true,
  },
  {
    path: "order2s/compensation",
    name: prefix + "compensation",
    component: () => import("@/views/order2s/Compensation.vue"),
    props: true,
  },
  {
    path: "order2s/billingnote",
    name: prefix + "billingnote",
    component: () => import("@/views/order2s/Billingnote.vue"),
    props: true,
  },  
  // {
  //   path: "shipment2slist",
  //   name: prefix + "shipment2SList",
  //   component: () => import("@/views/shipment/Shipment2SList.vue"),
  //   props: true,
  // },  
  {
    path: "order2s/shipment2slist/:status",
    name: prefix + "shipment2SList",
    component: () => import("@/views/shipment/Shipment2SList.vue"),
    props: true,
  },  
  {
    path: "order2s/shipment2s/:uoRefNo/:status",
    name: prefix + "shipment2SDetail",
    component: () => import("@/views/shipment/Shipment2SDetail.vue"),
    props: true,
  }, 
  {
    path: "customers",
    name: prefix + "customer",
    component: () => import("@/views/customer/CustomerList.vue"),
  },    
  {
    path: "management/roles",
    name: prefix + "roles",
    component: () => import("@/views/management/Role.vue"),
    meta: { authorize: [role.admin, role.owner] },
  },      
  {
    path: "customer/:contactID",
    name: prefix + "customerDetail",
    component: () => import("@/views/customer/CustomerDetail.vue"),
    props: true,
  },
  // {
  //   path: "admin/partners/:partnerCode/:contactID/customerdetail",
  //   name: prefix + "partnerCustomerDetail",
  //   component: () => import("@/views/customer/CustomerDetail.vue"),
  //   meta: { authorize: [role.admin] },
  //   props: true,
  // },      
  {
    path: "settings",
    name: prefix + "settings",
    component: () => import("@/views/account/Settings.vue"),
  },
  // {
  //   path: "admin/partners",
  //   name: prefix + "setpartner",
  //   component: () => import("@/views/admin/partner/SetPartner.vue"),
  //   meta: { authorize: [role.admin] },
  // },
  // {
  //   path: "admin/setprice",
  //   name: prefix + "setPrice",
  //   component: () => import("@/views/admin/product/SetPrice.vue"),
  //   meta: { authorize: [role.admin] },
  // },      
  {
    path: "overdueitems",
    name: prefix + "overdueItems",
    component: () => import("@/views/sellorder/OverdueItems.vue"),
  },
  // {
  //   path: "overdueitems/:partnerCode",
  //   name: prefix + "overdueItems",
  //   component: () => import("@/views/sellorder/OverdueItems.vue"),
  //   props: true,
  // },
  {
    path: "transfer/return",
    name: prefix + "return",
    component: () => import("@/views/transfer/Return.vue"),
    props: true
  },
  // {
  //   path: "admin/pricehistory/:productID",
  //   name: prefix + "priceHistory",
  //   component: () => import("@/views/admin/product/PriceHistory.vue"),
  //   props: true,
  //   meta: { authorize: [role.admin] },
  // },  
  {
    path: "admin/productpartner/:partnerCode",
    name: prefix + "productPartner",
    component: () => import("@/views/admin/partner/ProductPartner.vue"),
    props: true,
    meta: { authorize: [role.admin] },
  }, 
  // {
  //   path: "admin/setproductpartner/:partnerCode",
  //   name: prefix + "setProductPartner",
  //   component: () => import("@/views/admin/partner/SetProductPartner.vue"),
  //   props: true,
  //   meta: { authorize: [role.admin] },
  // },    
  // {
  //   path: "admin/setproduct/",
  //   name: prefix + "setProduct",
  //   component: () => import("@/views/admin/product/SetProduct.vue"),
  //   meta: { authorize: [role.admin] },
  // }, 
  // {
  //   path: "admin/campaign/",
  //   name: prefix + "campaignList",
  //   component: () => import("@/views/admin/campaign/CampaignList.vue"),
  //   meta: { authorize: [role.admin] },
  // },        
  // {
  //   path: "admin/campaign/create/",
  //   name: prefix + "createCampaign",
  //   component: () => import("@/views/admin/campaign/CreateCampaign.vue"),
  //   meta: { authorize: [role.admin] },
  // },   
  // {
  //   path: "admin/campaign/:campaignCode",
  //   name: prefix + "campaignDetail",
  //   component: () => import("@/views/admin/campaign/CampaignDetail.vue"),
  //   props: true,
  //   meta: { authorize: [role.admin] },
  // }, 
  // {
  //   path: "admin/reports/overdue/",
  //   name: prefix + "overdueReport",
  //   component: () => import("@/views/sellorder/OverdueReport.vue"),
  //   meta: { authorize: [role.admin] },
  // }, 
  // {
  //   path: "admin/reports/transfer/",
  //   name: prefix + "transfer",
  //   component: () => import("@/views/admin/reports/Transfer.vue"),
  //   meta: { authorize: [role.admin] },
  // },  
  // {
  //   path: "admin/reports/productnotmove/",
  //   name: prefix + "productnotmove",
  //   component: () => import("@/views/admin/reports/ProductNotMove.vue"),
  //   meta: { authorize: [role.admin] },
  // },  
  {
    path: "order/product-sales-summary",
    name: "productSalesSummaryReport",
    component: () => import("@/views/reports/SalesReport/SalesReport.vue"),
    props: true
  },
  {
    path: "reports/productnotmove/",
    name: prefix + "productNotMovePartner",
    component: () => import("@/views/admin/reports/ProductNotMove.vue"),
    // meta: { authorize: [role.user, role.manager, role.owner] },
  },     
  // {
  //   path: "products/transferbook",
  //   name: prefix + "transferbook",
  //   component: () => import("@/views/transfer/TransferBook.vue"),
  // },
  {
    path: "products/booking",
    name: prefix + "transfer",
    component: () => import("@/views/transfer/Transfer.vue"),
  },   
  {
    path: "products/transferbook/create",
    name: prefix + "transferbookcreate",
    component: () => import("@/views/transfer/TransferBookCreate.vue"),
  },  
  
  {
    path: "reports/productmovement",
    name: prefix +  "productmovement",
    component: () => import("@/views/reports/ProductMoveMent.vue"),
  },             
  {
    path: "reports/stocklongtime",
    name:  prefix + "stockLongTimePartner",
    component: () => import("@/views/reports/StockLongTime.vue"),
   // meta: { authorize: [role.user, role.manager, role.owner] },
  },   
  {
    path: "order/product-sellorder",
    name:  prefix + "productSellorder",
    component: () => import("@/views/reports/SellOrderReport/ProductSellorder.vue"),
   // meta: { authorize: [role.user, role.manager, role.owner] },
  },   

]

const adminRoutes: Array<RouteRecordRaw> = [
  {
    path: "/dashboard",
    name: "adminDashboard",
    component: () => validateRole(role.admin) ?  import("@/views/admin/Dashboard.vue") : import("@/views/Dashboard.vue"),
  },
  {
    path: "admin/partners/:partnerCode/stock",
    name: "partnerStock",
    component: () => import("@/views/stock/Stock.vue"),
    meta: { authorize: [role.admin] },
    props: true
  },
  {
    path: "admin/reports/orders",
    name: "adminReportOrder",
    component: () => import("@/views/admin/orders/PartnerOrderSummaryReport.vue"),
    meta: { authorize: [role.admin] }
  },
  {
    path: "/admin/reports/partners/:partnerCode/orders",
    name: "partnerOrderList",
    component: () => import("@/views/order/OrderList.vue"),
    props: true,
    meta: { authorize: [role.admin] }
  },
  {
    path: "/partners/:partnerCode/customer/:contactID",
    name: "partnerCustomerDetail",
    component: () => import("@/views/customer/CustomerDetail.vue"),
    meta: { authorize: [role.admin] },
    props: true,
  },    
  {
    path: "/admin/reports/customer",
    name: "partnerCustomer",
    component: () => import("@/views/customer/CustomerList.vue"),
    meta: { authorize: [role.admin] },
    props: true
  },  
  {
    path: "/admin/reports/partners/:partnerCode/orders/:orderCode",
    name: "partnerOrderDetail",
    component: () => import("@/views/order/OrderDetail.vue"),
    props: true,
    meta: { authorize: [role.admin] }
  },
  {
    path: "/admin/reports/partners/:partnerCode/orders/:srCode",
    name: "partnerSellRequestDetail",
    component: () => import("@/views/sellrequest/SellRequestDetail.vue"),
    props: true,
  },
  {
    path: "/partners",
    name: "setpartner",
    component: () => import("@/views/admin/partner/SetPartner.vue"),
    meta: { authorize: [role.admin] },
  },
  // {
  //   path: "reports/product-sales-summary",
  //   name: prefix + "productSalesSummaryReport",
  //   component: () => import("@/views/reports/SalesReport/SalesReport.vue"),
  //   props: true
  // },
  {
    path: "/admin/reports/salereports/product-sales-summary",
    name: "adminProductSalesSummaryReport",
    component: () => import("@/views/reports/SalesReport/SalesReport.vue"),
    props: true,
    meta: { authorize: [role.admin] }
  },
  {
    path: "/admin/setprice",
    name: "setPrice",
    component: () => import("@/views/admin/product/SetPrice.vue"),
    meta: { authorize: [role.admin] },
  },  
  {
    path: "/admin/pricehistory/:productID",
    name: "priceHistory",
    component: () => import("@/views/admin/product/PriceHistory.vue"),
    props: true,
    meta: { authorize: [role.admin] },
  },
  {
    path: "/admin/productpartner/:partnerCode",
    name: "productPartner",
    component: () => import("@/views/admin/partner/ProductPartner.vue"),
    props: true,
    meta: { authorize: [role.admin] },
  },
  {
    path: "/admin/partners/setproductpartner/:partnerCode",
    name: "setProductPartner",
    component: () => import("@/views/admin/partner/SetProductPartner.vue"),
    props: true,
    meta: { authorize: [role.admin] },
  },
  {
    path: "/admin/products/setproduct/",
    name: "setProduct",
    component: () => import("@/views/admin/product/SetProduct.vue"),
    meta: { authorize: [role.admin] },
  },
  {
    path: "/admin/campaign/",
    name: "campaignList",
    component: () => import("@/views/admin/campaign/CampaignList.vue"),
    meta: { authorize: [role.admin] },
  },
  {
    path: "/admin/campaign/create/",
    name: "createCampaign",
    component: () => import("@/views/admin/campaign/CreateCampaign.vue"),
    props: true,
    meta: { authorize: [role.admin] },
  },
  {
    path: "/admin/campaign/:campaignCode",
    name: "campaignDetail",
    component: () => import("@/views/admin/campaign/CampaignDetail.vue"),
    props: true,
    meta: { authorize: [role.admin] },
  },
  {
    path: "/admin/reports/overdue/",
    name: "overdueReport",
    component: () => import("@/views/sellorder/OverdueReport.vue"),
    meta: { authorize: [role.admin] },
  },
  {
    path: "/admin/reports/transfers/",
    name: "transfers",
    component: () => import("@/views/admin/reports/Transfer.vue"),
    meta: { authorize: [role.admin] },
  },
  {
    path: "/admin/reports/productnotmove/",
    name: "productNotMove",
    component: () => import("@/views/admin/reports/ProductNotMove.vue"),
    meta: { authorize: [role.admin] },
  },  
  {
    path: "/admin/reports/stocklongtime",
    name: "stockLongTime",
    component: () => import("@/views/admin/reports/StockLongTime.vue"),
    meta: { authorize: [role.admin] },
  },  
  {
    path: "/admin/news/",
    name: "newsList",
    component: () => import("@/views/admin/news/NewsList.vue"),
    meta: { authorize: [role.admin] },
  },
  {
    path: "/admin/news/create/",
    name: "createNews",
    component: () => import("@/views/admin/news/CreateNews.vue"),
    props: true,
    meta: { authorize: [role.admin] },
  },  
  {
    path: "/admin/news/:newsCode",
    name: "newsDetail",
    component: () => import("@/views/admin/news/NewsDetail.vue"),
    props: true,
    meta: { authorize: [role.admin] },
  },
  
  // {
  //   path: "/admin/reports/productsellorder",
  //   name: "productSellorder",
  //   component: () => import("@/views/reports/SellOrderReport/ProductSellorder.vue"),
  //   meta: { authorize: [role.admin] },
  //  // meta: { authorize: [role.user, role.manager, role.owner] },
  // },     
  {
    path: "/admin/reports/sellorderreport/product-sellorder",
    name: "adminProductSellorder",
    component: () => import("@/views/reports/SellOrderReport/ProductSellorder.vue"),
    props: true,
    meta: { authorize: [role.admin] }
  }, 
  {
    path: "/partners/:basePartnerCode",
    name: "partnerView",
    redirect: {
      name: "dashboard"
    },
    component: () => import("@/views/PartnerView.vue"),
    props: true,
    // meta: { authorize: [role.admin] },
    children: createChildren(""),
  },  
  // {
  //   path: "/partners/:basePartnerCode",
  //   name: "partnerView",
  //   redirect: {
  //     name: "dashboard"
  //   },
  //   component: () => import("@/layout/Layout.vue"),
  //   props: true,
  //   // meta: { authorize: [role.admin] },
  //   children: createChildren(""),
  // }
]

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "baseLayout",
    // redirect: "/",
    
    component: () => import("@/layout/Layout.vue"),
    meta: { authorize: true }
    // children: [
    //   ...adminRoutes
    // ]
      // ...createChildren(),
      // {
      //   redirect: {
      //     name: "partnerViewdashboard"
      //   },
      //   path: "/partners/:basePartnerCode",
      //   name: "partnerView",
      //   component: () => import("@/views/PartnerView.vue"),
      //   props: true,
      //   // meta: { authorize: [role.admin] },
      //   children: [
      //     ...createChildren("partnerView"),
      //     {
      //       path: "dashboard",
      //       name: "partnerViewdashboard",
      //       component: () => import("@/views/Dashboard.vue"),
      //     },        
      //   ]
      // }, 
      // {
      //   path: "dashboard",
      //   name: "dashboard",
      //   component: () => validateRole(role.admin) ?  import("@/views/admin/Dashboard.vue") : import("@/views/Dashboard.vue"),
      // },
      // {
      //   path: "/stock",
      //   name: "stock",
      //   component: () => import("@/views/stock/Stock.vue"),
      //   // meta: { authorize: [role.admin] },
      // },
      // {
      //   path: "/2s/stock",
      //   name: "2SStock",
      //   component: () => import("@/views/stock/2SStock.vue"),
      //   // meta: { authorize: [role.admin] },
      // },
      // {
      //   path: "/receive",
      //   name: "receive",
      //   component: () => import("@/views/transfer/Receive.vue"),
      // },
      // {
      //   path: "/sellorderreport",
      //   name: "sellorderreport",
      //   component: () => import("@/views/sellorder/SellOrderReport.vue"),
      // },
      // {
      //   path: "/overduereport",
      //   name: "overduereport",
      //   component: () => import("@/views/sellorder/OverdueReport.vue"),
      // },
      // // {
      // //   path: "/admin/reports/product-sales-summary",
      // //   name: "adminProductSalesSummaryReport",
      // //   component: () => import("@/views/reports/ProductSalesSummaryReport.vue"),
      // //   props: true,
      // //   meta: { authorize: [role.admin] }
      // // },
      // {
      //   path: "/salereports/product-sales-summary",
      //   name: "productSalesSummaryReport",
      //   component: () => import("@/views/reports/SalesReport/SalesReport.vue"),
      //   props: true
      // },
      // {
      //   path: "/order/create",
      //   name: "createOrder",
      //   component: () => import("@/views/order/CreateOrder.vue"),
      //   meta: { notCatch: true}
      // },
      // {
      //   path: "/order/:orderCode",
      //   name: "orderDetail",
      //   component: () => import("@/views/order/OrderDetail.vue"),
      //   props: true,
      // },
      // {
      //   path: "/order",
      //   name: "orderList",
      //   component: () => import("@/views/order/OrderList.vue"),
      //   props: true,
      // },
      // {
      //   path: "/customer",
      //   name: "customer",
      //   component: () => import("@/views/customer/CustomerList.vue"),
      // },
      // {
      //   path: "admin/partners/:partnerCode/customer",
      //   name: "partnerCustomer",
      //   component: () => import("@/views/customer/CustomerList.vue"),
      //   meta: { authorize: [role.admin] },
      //   props: true
      // },      
      // {
      //   path: "/management/roles",
      //   name: "roles",
      //   component: () => import("@/views/management/Role.vue"),
      //   meta: { authorize: [role.admin, role.owner] },
      // },
      // {
      //   path: "/customerdetail/:contactID",
      //   name: "customerDetail",
      //   component: () => import("@/views/customer/CustomerDetail.vue"),
      //   props: true,
      // },
      // {
      //   path: "/settings",
      //   name: "settings",
      //   component: () => import("@/views/account/Settings.vue"),
      // },
      // {
      //   path: "/overdueitems",
      //   name: "overdueItems",
      //   component: () => import("@/views/sellorder/OverdueItems.vue"),
      // },
      // {
      //   path: "/return",
      //   name: "return",
      //   component: () => import("@/views/transfer/Return.vue"),
      // },
      // {
      //   path: "/returnproduct",
      //   name: "returnProduct",
      //   component: () => import("@/views/transfer/ReturnProductList.vue"),
      // },       
         
      // {
      //   path: "/transferbook",
      //   name: "transferbook",
      //   component: () => import("@/views/transfer/TransferBook.vue"),
      // },  
      // {
      //   path: "/transferbook/create",
      //   name: "transferbookcreate",
      //   component: () => import("@/views/transfer/TransferBookCreate.vue"),
      // },
      // {
      //   path: "/reports/productmovement",
      //   name: "productmovement",
      //   component: () => import("@/views/reports/ProductMoveMent.vue"),
      // },                                                                             
    // ],
  },
  {
    path: "/",
    name: "A",
    component: () => import("@/views/auth/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () => import("@/views/auth/SignIn.vue"),
      },
      {
        path: "/forget-password",
        name: "ForgetPassword",
        component: () => import("@/views/auth/ForgetPassword.vue"),
      },
      {
        path: "/reset-password",
        name: "ResetPassword",
        component: () => import("@/views/auth/ResetPassword.vue"),
      },   
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/error/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];



const gcurrentUser = store.getters.currentUser;

if(gcurrentUser ) {
  
  routes[0].children = gcurrentUser.role == role.admin ? adminRoutes : createChildren();

}

const router = createRouter({
  history: createWebHistory (),
  routes,
});



router.beforeEach((to, from, next) => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  store.dispatch(Actions.VERIFY_AUTH)
  
  const authorize = to.meta.authorize as string[];
  const currentUser = store.getters.currentUser;
  // console.log("role : ", currentUser.role)
  // console.log("from : ", from)
  // console.log("to : ", to)


  // if(currentUser)
  // {
  //   if(!from.name && from.path == '/') {
  
  //     if(currentUser.role == "admin" )
  //     {
  //       adminRoutes.forEach(r => {      
  //         router.addRoute('baseLayout', r)
  //       })
  //     }
  //     else 
  //     {
  //       createChildren().forEach(r => {
  //         console.log(r)    
  //         router.addRoute('baseLayout', r)
  //       })
  //     }
  //   }
  // }
  
  // console.log('from', from);
  // console.log('to', to);
  // console.log("name", to.name);
  // console.log("hasRoute", router.hasRoute(to.name ?? ""));
  // console.log("authorize", authorize);
  // console.log("!currentUser", !currentUser);
  // console.log("currentUser", currentUser);

  if (authorize) {
    

    if (!currentUser ||!currentUser.id) {
      
      // not logged in so redirect to login page with the return url
      return next({ path: "/sign-in", query: { returnUrl: to.path } });
    } 

    if(!currentUser.updatedDate)
    {
      return next({name: "ResetPassword"})
    }

    // check if route is restricted by role
    if (authorize.length && !authorize.includes(currentUser.role)) {
      // role not authorised so redirect to home page
      return next({ path: "/404" });
    }

    if(to.path == '/') {
      return next({ path: "/dashboard" });
    }
  }
  
  // Scroll page to top on every route change
  // setTimeout(() => {
    window.scrollTo(0, 0);
    next();
  // }, 100);
});


export default router;
